import { render, staticRenderFns } from "./CampoMontoTotal.vue?vue&type=template&id=4f1616f2&scoped=true&"
import script from "./CampoMontoTotal.vue?vue&type=script&lang=js&"
export * from "./CampoMontoTotal.vue?vue&type=script&lang=js&"
import style0 from "./CampoMontoTotal.vue?vue&type=style&index=0&id=4f1616f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1616f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1616f2')) {
      api.createRecord('4f1616f2', component.options)
    } else {
      api.reload('4f1616f2', component.options)
    }
    module.hot.accept("./CampoMontoTotal.vue?vue&type=template&id=4f1616f2&scoped=true&", function () {
      api.rerender('4f1616f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoMontoTotal.vue"
export default component.exports